export const setCoin = (coin) => ({
  type: "SET_COIN",
  payload: coin,
})

export const setChart = (chart) => ({
  type: "SET_CHART",
  payload: chart,
})
